"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _isNil = _interopRequireDefault(require("lodash/isNil"));
var _isString = _interopRequireDefault(require("lodash/isString"));
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _reactCollapse = require("react-collapse");
var _chevronDown = _interopRequireDefault(require("@spothero/icons/chevron-down"));
var _chevronUp = _interopRequireDefault(require("@spothero/icons/chevron-up"));
var _Button = _interopRequireDefault(require("../Button/Button"));
var _deprecate = _interopRequireDefault(require("../../utils/deprecate"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
(0, _deprecate.default)({
  name: 'Panel',
  newName: 'Accordion',
  changes: ['---- Props ----', 'Use allowMultiple to let multiple items show as expanded at a time', 'Use allowToggle to allow items within the accordion, so any expanded accordion item can be collapsed again', 'instead of isOpen now use, defaultIndex, index to achieve the same effect', 'Use defaultIndex to set the initial index(es) of the expanded accordion item', 'Use index to set the index(es) of the expanded accordion item', 'onChange is the callback invoked when accordion items are expanded or collapsed', 'Use isDisabled to disable an AccordionItem', 'Use isFocusable to allow an AccordionItem to be focusable', 'The pseudo style props _expanded, _disabled, _hover can be passed into the AccordionButton to style it', '---- Changes in v2 component  ----', 'Accordion (v2) now uses multiple components in order to parody this component', 'In Accordion (v2), there is no longer the option to pass in a custom icon', 'In Accordion (v2), the Title and Icon are now placed as children of AccordionButton component to enable the whole row to be clickable', 'The AccordionButton should be placed within a Heading component for markup and styling (v2/components/Heading)', 'In Accordion (v2), the Text is now a child of the AccordionPanel component', 'In order to add styles/markup to the text, it should be placed within a Text component (v2/components/Text)', 'Both AccordionPanel and AccordionIcon are children of AccordionItem', 'In Accordion (v2), showTitleToggle has been removed', 'In Accordion (v2), preview has been removed', 'onOpen and onClose are no longer needed in the v2 component', '---- Additional Information ----', 'new props are documented at: https://chakra-ui.com/docs/disclosure/accordion']
});
class Panel extends _react.Component {
  static defaultProps = {
    openIcon: /*#__PURE__*/_react.default.createElement(_chevronDown.default, {
      className: "Icon-chevron-down"
    }),
    closeIcon: /*#__PURE__*/_react.default.createElement(_chevronUp.default, {
      className: "Icon-chevron-up"
    })
  };
  state = {
    isOpen: this.props.isOpen || false,
    prevIsOpen: false,
    heightReady: false
  };
  static getDerivedStateFromProps(nextProps, prevState) {
    const {
      isOpen: nextIsOpen,
      showTitleToggle: nextShowTitleToggle
    } = nextProps;
    const {
      isOpen,
      prevIsOpen
    } = prevState;
    const isOpenStateEqualsNextProp = isOpen === nextIsOpen;

    // when showTitleToggle is true, we don't want Panel controlled externally
    if (!nextShowTitleToggle && isOpen !== prevIsOpen && isOpenStateEqualsNextProp) {
      // toggled internal state change
      return {
        isOpen,
        prevIsOpen
      };
    } else if (!nextShowTitleToggle && !isOpenStateEqualsNextProp) {
      // state change happening because of props change by external component
      return {
        isOpen: nextIsOpen,
        prevIsOpen: isOpen
      };
    }
    return null;
  }
  componentDidUpdate(prevProps, prevState) {
    const {
      onOpen,
      onClose
    } = this.props;
    const {
      isOpen
    } = this.state;
    const {
      isOpen: prevIsOpen
    } = prevState;
    if (onOpen && isOpen && !prevIsOpen) {
      onOpen();
    }
    if (onClose && !isOpen && prevIsOpen) {
      onClose();
    }
  }
  _onMeasure = () => {
    this.setState({
      heightReady: true
    });
  };
  _onToggle = evt => {
    evt.preventDefault();
    this.setState((prevState, props) => {
      const {
        isOpen
      } = prevState;
      return {
        isOpen: !isOpen,
        prevIsOpen: isOpen
      };
    });
  };
  render() {
    const {
      className,
      title,
      children,
      showTitleToggle,
      preview,
      additionalTitleMarkup,
      openIcon,
      closeIcon
    } = this.props;
    const {
      isOpen,
      heightReady
    } = this.state;
    const classes = (0, _classnames.default)('Panel', {
      'Panel-with-preview': preview
    }, {
      'Panel-open': isOpen
    }, className);
    const contentClasses = (0, _classnames.default)('Panel-content', {
      'Panel-content-hidden': !heightReady
    });
    const showPreview = !(0, _isNil.default)(preview) && !isOpen;
    const panelTitle = (0, _isString.default)(title) ? /*#__PURE__*/_react.default.createElement("div", {
      className: "Panel-title-heading"
    }, title) : title;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: classes
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "Panel-title"
    }, showTitleToggle ? /*#__PURE__*/_react.default.createElement(_Button.default, {
      className: "Panel-toggle",
      onClick: this._onToggle
    }, panelTitle, isOpen ? closeIcon : openIcon) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, panelTitle, additionalTitleMarkup)), /*#__PURE__*/_react.default.createElement(_reactCollapse.Collapse, {
      isOpened: isOpen || showPreview,
      onMeasure: this._onMeasure,
      springConfig: {
        stiffness: 300,
        damping: 25
      }
    }, isOpen && /*#__PURE__*/_react.default.createElement("div", {
      className: contentClasses
    }, children), showPreview && /*#__PURE__*/_react.default.createElement("div", {
      className: "Panel-preview"
    }, preview)));
  }
}
var _default = exports.default = Panel;